
$( document ).ready(function() {
    communications.init();
});

var communications = {
    container: null,

    init: function(container) {
        this.container = container || $('#communications');
        communications.registerCommunicationLine(this.container);
    },

    registerCommunicationLine: function(container) {
        connection.applyValueChange(container.find('input'), {
            onChange: function(formEl) {
                var row = formEl.parents('.d-flex[data-id]');
                if (row.attr('data-id') !== '') {
                    communications.saveCommunication(row);
                }
            }
        });
        container.find('[data-save]').click(function() {
            var row = $(this).parents('.d-flex[data-id]');
            communications.saveCommunication(row);
        });
        container.find('[data-del]').click(function() {
            var row = $(this).parents('.d-flex[data-id]');
            var id = row.attr('data-id');
            if (id.length == 0) return;

            messaging.askYesNo('Kommunikationsmittel löschen?', 'Willst du dieses Kommunikationsmittel löschen?', function() {
                communications.deleteCommunication(row);
            });
        });
    },

    saveCommunication: function(row) {
        var id = row.attr('data-id');
        var container = $(row.parents('.communications')[0]);
        // var task = {
        //     run: function(onComplete, onTaskError) {
                if (row.find('[name=Type]').val() && row.find('[name=Value]').val()) {
                    connection.getJson(container.attr('data-savehref') + '/' + id, {
                        type: 'POST',
                        timeout: connection.defaultTimeout,
                        data: {
                            type: row.find('[name=Type]').val(),
                            value: row.find('[name=Value]').val(),
                            targetId: container.attr('data-targetId')
                        },
                        onSuccess: function(data) {
                            messaging.showGlobalMessage("success", null, "Das Kommunikationsmittel wurde gespeichert.");
                        },
                        onError: function(err) {
                            //
                        },
                    });

                    /*$.ajax({
                        url: container.attr('data-savehref') + '/' + id,
                        data: {
                            type: row.find('[name=Type]').val(),
                            value: row.find('[name=Value]').val(),
                            targetId: container.attr('data-targetId')
                        },
                        type: 'post',
                        dataType: 'json',
                        timeout: connection.defaultTimeout,
                        success: function (data) {
                            messaging.showGlobalMessage("success", null, "Das Kommunikationsmittel wurde gespeichert.");
                            // if (id === "") {
                            //     row.removeClass('isnew').attr('data-id', data.id);
                            //     row.find('[data-del].disabled').removeClass('disabled');
                            //     var contentEl = $(data.emptyContent.trim());
                            //     contentEl.insertAfter(row);
                            //     communications.registerCommunicationLine(contentEl);
                            // }
                            if (id === "") {
                                slidein.loadSlideIn('/Address/EditContactSlideIn?addressId=' + container.attr('data-targetId'));
                            }
                            connection.loadPart($('#comms-list'));
                        },
                        error: function (data) {
                            if (data.statusText == 'timeout') {
                                onTaskError(null, true);
                                return;
                            }
                            onTaskError("Das Kommunikationsmittel konnte nicht gespeichert werden: " + connection.getErrorMessageOf(data, ''), false, function () {
                                //revert
                            });
                        },
                        complete: function () {
                            if (onComplete != null) onComplete();
                        }
                    });*/
                // } else {
                //     if (onComplete != null) onComplete();
                }
            // }
        // };
        // taskQueue.add(task);
    },

    deleteCommunication: function(row) {
        var id = row.attr('data-id');
        var container = $(row.parents('.communications')[0]);
        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: container.attr('data-deletehref')+'/'+id,
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function() {
                        messaging.showGlobalMessage("success", null, "Das Kommunikationsmittel wurde gelöscht.");
                        row.remove();
                        connection.loadPart($('#comms-list'));
                    },
                    error: function(data) {
                        if (data.statusText == 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError("Das Kommunikationsmittel konnte nicht gelöscht werden: " + connection.getErrorMessageOf(data, ''), false, function() {
                            //revert
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    }

};
window.communications = communications;
